import i18n from '../../locales/i18n'
import { CountryCode } from '../../types'

export const CityTitle = {
  [CountryCode.US]: i18n.t('Regions:TERRITORY.CITY'),
  [CountryCode.CA]: i18n.t('Regions:TERRITORY.MUNICIPALITY'),
  [CountryCode.ES]: i18n.t('Regions:TERRITORY.CITY'),
  [CountryCode.PT]: i18n.t('Regions:TERRITORY.CITY'),
  [CountryCode.BR]: i18n.t('Regions:TERRITORY.CITY'),
}
